import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import Loading from "../../Components/Loading/Loading";
import styles from "../AddContacts/AddContacts.module.css";
import { connect, useDispatch } from "react-redux";
import { themeColors } from "../../Components/theme";
import { useHistory } from "react-router";
import TextInput from "../../Components/TextInput/InputText";
import { showSnackbarAction } from "../../Redux/actions";
import { fetchOrganizationsUserDropDown } from "../../Services/organizations";
import axios from "axios";
import { url } from "../../Values/constants";
import "../../theme-vars.css";
import { Circles } from 'react-loader-spinner';
import { useTheme, useMediaQuery } from "@mui/material";
import { Button } from "@mui/material";
import { Grid } from "@material-ui/core";
import DropDownText from "../../Components/DropDownText/DropDownText";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";

type props = {
  theme: any;
  authToken: any;
  user: any;
};

const UpdatePassword: FunctionComponent<props> = ({ theme, authToken, user }) => {
  const history = useHistory();
  const newPasswordRef: any = useRef();
  const confirmNewPasswordRef: any = useRef();
  const dispatcher = useDispatch();
  const [load, setLoad] = useState(false);
  const [finalDataList, setFinalDataList] = useState<any[]>([]);
  const [emailSelected, setEmailSelected] = useState<any | null>(null);
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  useEffect(() => {
    fetchOrganizationsUserDropDown(user.organization_id, (data) =>
      setFinalDataList(data)
    );
  }, [user.uid]);

  const handleEmailSelection = (e: any) => {
    const selectedUid = e.target.value;
    const selectedEmail = finalDataList.find((option) => option.uid === selectedUid);
    setEmailSelected(selectedEmail);
  };

  const create = async (e: any) => {
    e.preventDefault();
    if (!emailSelected) {
      dispatcher(showSnackbarAction("User Email Required!!", "error"));
      return;
    } else if (newPasswordRef.current.value === "") {
      dispatcher(showSnackbarAction("New Password Required!!", "error"));
      return;
    } else if (confirmNewPasswordRef.current.value === "") {
      dispatcher(showSnackbarAction("Confirm New Password Required!!", "error"));
      return;
    } else if (confirmNewPasswordRef.current.value !== newPasswordRef.current.value) {
      dispatcher(
        showSnackbarAction(
          "Confirm Password and New Password should be same",
          "error"
        )
      );
      return;
    }
    setLoad(true);
    updateUserAuth();
  };

  const updateUserAuth = async () => {
    const bodyData = {
      uid: emailSelected.uid,
      newEmail: emailSelected.user_email,
      newPassword: newPasswordRef.current.value,
    };
    try {
      const repUpdateUserAuth = await axios.post(
        url + "/utils/firebase-updateUser",
        bodyData
      );
      if (repUpdateUserAuth?.status === 200) {
        setLoad(false);
        dispatcher(
          showSnackbarAction("Password changed successfully!!", "success")
        );
        history.push("/");
      }
    } catch (error) {
      setLoad(false);
    }
  };
  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  const cardContainerStyles = {
    backgroundColor: theme
      ? themeColors.cardBackgroundColor
      : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  return (
    <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
      {load === true && <Loading />}
      {isMobile && (
        <div className="d-flex flex-row w-100 px-4 pt-2">
          <h5 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>Update Password</h5>
        </div>
      )}
      <div className="w-100 d-flex flex-column gap-2 px-4" style={{ padding: isMobile ? '0' : '', maxWidth: isMobile ? '100vw' : undefined, margin: isMobile ? '0' : '0 auto' }}>
        <form
          className="card p-4 shadow rounded mt-2"
          style={{ ...cardContainerStyles, padding: isMobile ? '16px' : '32px', boxSizing: 'border-box' }}
          // onSubmit={create}
        >
          <Grid container spacing={isMobile ? 2 : 3}>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title="User Email"
                options={finalDataList}
                value={emailSelected ? emailSelected.uid : ""}
                onChange={handleEmailSelection}
                required
                labelKey="user_email"
                valueKey="uid"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="New Password"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={newPasswordRef}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="Confirm Password"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={confirmNewPasswordRef}
                required={true}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: 12 }}>
              <StyledSubmitButton
                onClick={create}
                themeMode={themeMUI.palette.mode}
                isMobile={isMobile}
              >
                {load ? (
                  <span style={{ display: "flex", justifyContent: "center" }}>
                    <Circles color="#fff" height={20} width={20} />
                  </span>
                ) : (
                  <>Submit</>
                )}
              </StyledSubmitButton>
            </Grid>
          </Grid>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    authToken: state.user.authToken,
  };
};

export default connect(mapStateToProps)(UpdatePassword);
